

export default class HoseModel {
  constructor(data = {}) {
    
    let template = {
      id: 0,
      hoseName: null,
      couplingType: null,
      diameter: null,
      material: null,
      lengthM: null,
      status: null,
      inServiceDate: null,
      decommissionedDate: null,
      createdAt: null,
      createdBy: null,
      updatedAt: null,
      updatedBy: null
    }

    this.data = data ? data : template;
  }

  /** 
   * This is used for application code to confirm 
   * the object is indeed a HoseModel
   */
  getType = () => {
    return "HoseModel";
  }

  getId = () => {
    return this.data.id;
  }
  setId = (value) => {
    this.data.id = value;
  }

  getHoseName = () => {
    return this.data.hoseName;
  }
  setHoseName = (value) => {
    this.data.hoseName = value;
  }
  
  getCouplingType = () => {
    return this.data.couplingType;
  }
  setCouplingType = (value) => {
    this.data.couplingType = value;
  }

  getDiameter = () => {
    return this.data.diameter;
  }
  setDiameter = (value) => {
    this.data.diameter = value;
  }

  getMaterial = () => {
    return this.data.material;
  }
  setMaterial = (value) => {
    this.data.material = value;
  }

  getLengthM = () => {
    return this.data.lengthM;
  }
  setLengthM = (value) => {
    this.data.lengthM = value;
  }

  getStatus = () => {
    return this.data.status;
  }
  setStatus = (value) => {
    this.data.status = value;
  }

  getInServiceDate = () => {
    return this.data.inServiceDate;
  }
  setInServiceDate = (value) => {
    this.data.inServiceDate = value;
  }

  getDecommissionedDate = () => {
    return this.data.decommissionedDate;
  }
  setDecommissionedDate = (value) => {
    this.data.decommissionedDate = value;
  }

  getCreatedAt = () => {
    return this.data.createdAt;
  }
  setCreatedAt = (value) => {
    this.data.createdAt = value;
  }

  getCreatedBy =  () => {
    return this.data.createdBy;
  }
  setCreatedBy = (value) => {
    this.data.createdBy = value;
  }

  getUpdatedAt = () => {
    return this.data.updatedAt;
  }
  setUpdatedAt = (value) => {
    this.data.updatedAt = value;
  }
  
  getUpdatedBy = () => {
    return this.data.updatedBy;
  }
  setUpdatedBy = (value) => {
    this.data.updatedBy = value;
  }


  toJson = () =>{
    return JSON.stringify(this.data);
  }
}